/** Carga de uma pessoa nos próximos dias: ajuda a escolher a data ao criar ou atribuir uma atividade. */
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface Load { overdue: number; days: Array<{ day: string; weekday: number; holiday: boolean; count: number; fatal: number }> }
const WD = ["D", "S", "T", "Q", "Q", "S", "S"];

export function LoadStrip({ userId, selected, onPick }: { userId: string | null | undefined; selected?: string; onPick: (day: string) => void }): JSX.Element | null {
  const { data } = useQuery({ queryKey: ["carga-pessoa", userId], enabled: !!userId, queryFn: () => api.get<Load>(`/atividades-carga/${userId}?dias=15`), staleTime: 60_000 });
  if (!userId) return null;
  if (!data) return <div className="muted small">Carregando a agenda da pessoa…</div>;
  const max = Math.max(3, ...data.days.map((d) => d.count));
  return (
    <div className="load-strip">
      <div className="ls-head"><b className="small">Carga nos próximos 15 dias</b>{data.overdue > 0 && <span className="text-bad small"> · {data.overdue} atrasada(s)</span>}<span className="muted small"> · clique no dia para usar</span></div>
      <div className="ls-days">
        {data.days.map((d) => {
          const off = d.weekday === 0 || d.weekday === 6 || d.holiday;
          const lvl = d.count === 0 ? 0 : d.count / max < 0.34 ? 1 : d.count / max < 0.67 ? 2 : 3;
          return (
            <button type="button" key={d.day} className={`ls-day h${lvl} ${off ? "off" : ""} ${selected === d.day ? "on" : ""}`} onClick={() => onPick(d.day)}
              title={`${d.day.split("-").reverse().join("/")}: ${d.count} atividade(s)${d.fatal ? `, ${d.fatal} prazo(s) fatal(is)` : ""}${d.holiday ? " · feriado" : ""}`}>
              <small>{WD[d.weekday]}</small><b>{Number(d.day.slice(8))}</b><span>{d.count || ""}{d.fatal ? <i>⚑</i> : null}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
